import { OverlayTrigger, Tooltip} from "react-bootstrap";
import { ArrowRightCircle, Clock, CheckCircle, XCircle, StopCircle } from "react-feather";

import getActivityDateTimeDisplay from "./datetime";

// Dashed circle matching the react-feather circle icons, muted so n/a recedes
function NotApplicableCircle({ size = 24 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="3 4"
      style={{ color: "#b8bfc7" }}
    >
      <circle cx="12" cy="12" r="10" />
    </svg>
  );
}

function ParticipationStatusIcon({ notApplicable, inProgress, isPending, isActive, isStopped=false, pendingTimestamp, size=24 }) {
  if (isStopped) {
    return (
      <OverlayTrigger
        trigger={["hover", "focus"]}
        placement="bottom"
        overlay={<Tooltip>Expired or Resigned</Tooltip>}
      >
        <span>
          <StopCircle className="text-muted" size={size} />
        </span>
      </OverlayTrigger>
    );
  }
  
  if (notApplicable) {
    return (
      <OverlayTrigger
        trigger={["hover", "focus"]}
        placement="bottom"
        overlay={<Tooltip>Not Applicable</Tooltip>}
      >
        <span style={{ cursor: "default" }}>
          <NotApplicableCircle size={size} />
        </span>
      </OverlayTrigger>
    );
  }

  if (inProgress) {
    return (
      <OverlayTrigger
        trigger={["hover", "focus"]}
        placement="bottom"
        overlay={<Tooltip>In Progress</Tooltip>}
      >
        <span>
          <ArrowRightCircle className="text-muted" size={size} />
        </span>
      </OverlayTrigger>
    );
  }

  if (isPending) {
    return (
      <OverlayTrigger
        trigger={["hover", "focus"]}
        placement="bottom"
        overlay={<Tooltip>Submitted{pendingTimestamp ? `: ${getActivityDateTimeDisplay(pendingTimestamp, false, false, false, false, true)}` : ""}</Tooltip>}
      >
        <span>
          <Clock className="text-warning" size={size} />
        </span>
      </OverlayTrigger>
    );
  }

  if (isActive) {
    return (
      <OverlayTrigger
        trigger={["hover", "focus"]}
        placement="bottom"
        overlay={<Tooltip>Active</Tooltip>}
      >
        <span>
          <CheckCircle className="text-success" size={size} />
        </span>
      </OverlayTrigger>
    );
  }

  return (
    <OverlayTrigger
      trigger={["hover", "focus"]}
      placement="bottom"
      overlay={<Tooltip>Inactive</Tooltip>}
    >
      <span>
        <XCircle className="text-danger" size={size} />
      </span>
    </OverlayTrigger>
  );
}

export default ParticipationStatusIcon;